// @ts-nocheck
import React from 'react';

interface AdminLoadingSkeletonProps {
  rows?: number;
  columns?: number;
  showHeader?: boolean;
  className?: string;
}

export const AdminLoadingSkeleton: React.FC<AdminLoadingSkeletonProps> = ({
  rows = 5,
  columns = 4,
  showHeader = true,
  className = '',
}) => {
  return (
    <div className={`bg-white dark:bg-luna-primary rounded-xl border-2 border-luna-secondary/30 overflow-hidden ${className}`}>
      <div className="overflow-x-auto">
        <table className="w-full">
          {showHeader && (
            <thead className="bg-luna-secondary/10">
              <tr>
                {Array.from({ length: columns }).map((_, i) => (
                  <th key={i} className="px-4 py-3 text-left">
                    <div className="h-4 bg-luna-secondary/20 rounded animate-pulse w-24" />
                  </th>
                ))}
              </tr>
            </thead>
          )}
          <tbody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <tr key={rowIndex} className="border-t border-luna-secondary/10">
                {Array.from({ length: columns }).map((_, colIndex) => (
                  <td key={colIndex} className="px-4 py-3">
                    <div className="h-4 bg-luna-secondary/10 rounded animate-pulse w-full" />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

interface AdminCardSkeletonProps {
  count?: number;
}

export const AdminCardSkeleton: React.FC<AdminCardSkeletonProps> = ({ count = 3 }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="bg-white dark:bg-luna-primary rounded-xl border-2 border-luna-secondary/30 p-6"
        >
          <div className="h-4 bg-luna-secondary/20 rounded animate-pulse w-3/4 mb-4" />
          <div className="h-8 bg-luna-secondary/10 rounded animate-pulse w-1/2 mb-2" />
          <div className="h-3 bg-luna-secondary/10 rounded animate-pulse w-full" />
        </div>
      ))}
    </div>
  );
};

